// extracted by mini-css-extract-plugin
module.exports = {"links":"links_links__ER9JT","links-desktop":"links_links-desktop__SMLMY","links-mobile":"links_links-mobile__SKXpL"};